import './App.css';
import {Canvas, ReactThreeFiber} from '@react-three/fiber'
import * as THREE from 'three'
import React, { Suspense, useState } from 'react';
import { OrbitControls, useTexture } from '@react-three/drei';
import Player from './Components/Player';
import Space1 from './Components/Space1';
import Space2 from './Components/Space2';
import Space3 from './Components/Space3';
import Space4 from './Components/Space4';
import Space5 from './Components/Space5';
import {space1WallData, space2WallData, space3WallData, space4WallData, space5WallData} from './Components/wallData'
import { Physics } from '@react-three/cannon';



function App() {

  const [activeSpaceId, setActiveSpaceId] = useState(1)

  const renderSpace = (id) => {
    switch (id) {
      case 1:
        return <>
          <Space3 wallData={space3WallData} />
        </>

      case 2:
        return <>
          <Space1 wallData={space1WallData} />
        </>

      case 3:
        return <>
          <Space2 wallData={space2WallData} />
        </>

      case 4:
        return <>
          <Space4 wallData={space4WallData} />
        </>

      case 5:
        return <>
          <Space5 wallData={space5WallData} />
        </>

      default:
        return <>
          <Space3 wallData={space3WallData} />
        </>
    }
  }

  return (
    <div className="App">
      <div className="spaces-link">
        <button onClick={() => setActiveSpaceId(1) }>1</button>
        <button onClick={() => setActiveSpaceId(2) }>2</button>
        <button onClick={() => setActiveSpaceId(3) }>3</button>
        <button onClick={() => setActiveSpaceId(4) }>4</button>
        <button onClick={() => setActiveSpaceId(5) }>5</button>
      </div>
      <Canvas
        gl={{ alpha: false, antialias: true }}
        camera={{ fov: 45, position: [0, 131, 0] }}
        onCreated={({ gl }) => {
          gl.outputEncoding = THREE.sRGBEncoding
          gl.gammaFactor = 2.2;
          gl.toneMapping = THREE.LinearToneMapping
        }}
        dpr={Math.min(2, window.devicePixelRatio)}
      >
        <Physics gravity={[0, -300, 0]}>
          <Suspense fallback={null} >
            {renderSpace(activeSpaceId)}
            <Player/>
          </Suspense>
        </Physics>
      </Canvas>
      
    </div>
  );
}

export default App;
